import { createAction, props } from '@ngrx/store';
import { ServiceError, ServiceErrorWithList } from '../../create-request/models/shared/ServiceError';
import { InternalTransferInputResponse } from '../../create-request/models/internal-transfer/InternalTransferInputResponse';
import { InternalTransferInputRequest } from '../../create-request/models/internal-transfer/InternalTransferInputRequest';
import { StandingAuthorizationForm } from '../models/standingAuthorizationForm';
import { InternalTransferVerifyResponse } from '../../create-request/models/internal-transfer/InternalTransferVerifyResponse';
import { InternalTransferAcknowledgeResponse } from '../../create-request/models/internal-transfer/InternalTransferAcknowledgeResponse';

export const loadToAccountFail = createAction(
  '[Create Standing Authorization - Internal Transfer] Error loading To Account',
  props<ServiceError>()
);

export const loadToAccountSuccess = createAction(
  '[Create Standing Authorization - Internal Transfer] To Account Successfully loaded',
  props<{ internalTransferInputResponse: InternalTransferInputResponse }>()
);

export const loadToAccountFinishedWithError = createAction(
  '[Create Standing Authorization - Internal Transfer] Load to account has error',
  props<{ internalTransferInputResponse: InternalTransferInputResponse }>()
);

export const toAccountEntered = createAction(
  '[Create Standing Authorization - Internal Transfer] To Account Entered',
  props<{ payload: InternalTransferInputRequest }>()
);

export const clearToAccount = createAction(
  '[Create Standing Authorization - Internal Transfer] Clear to account'
);

export const callInternalTransferVerify = createAction(
  '[Create Standing Authorization - Internal Transfer] Call internal transfer verify',
  props<StandingAuthorizationForm>()
);

export const verifyCallSuccessful = createAction(
  '[Create Standing Authorization - Internal Transfer] Call to verify was successful',
  props<{ response: InternalTransferVerifyResponse }>()
);

export const verifyCallFinishedWithError = createAction(
  '[Create Standing Authorization - Internal Transfer] Verify call has error',
  props<{ response: InternalTransferVerifyResponse }>()
);

export const verifyCallFail = createAction(
  '[Create Standing Authorization - Internal Transfer] Error calling verify',
  props<ServiceError>()
);

export const callAcknowledge = createAction(
  '[Create Standing Authorization - Internal Transfer] Call to internal transfer acknowledge'
);

export const acknowledgeCallSuccessful = createAction(
  '[Create Standing Authorization - Internal Transfer] Call to internal transfer acknowledge was successful',
  props<{ response: InternalTransferAcknowledgeResponse }>()
);

export const acknowledgeCallFail = createAction(
  '[Create Standing Authorization - Internal Transfer] Call to internal transfer acknowledge failed',
  props<ServiceErrorWithList>()
);

export const loadInternalTransferReviewPageWithoutVerifyCall = createAction(
  '[Create Standing Authorization - Load internal transfer Review page without calling verify endpoint',
  props<StandingAuthorizationForm>()
);

export const clearStandingAuthInternalTransferResponse = createAction(
  '[Create Standing Authorization - Internal Transfer] Clear Internal Transfer Auth Response for Custom Rules'
);
